<template>
    <div id="#contato">
        <b-sidebar id="sidebar-right" title="Sidebar"  background-variant="white" backdrop shadow right width="800px" no-header>
            <template #default="{hide}">
                <div class="row">

                    <div class="col-10 text-center entreemcontato">
                        <span> Entre em contato</span>
                    </div>
                    <div class="col-1 text-center mr-4 entreemcontato">
                        <span class="mr-4 btn-fechar" @click="hide">x</span>
                    </div>
                </div>
                <div class="px-3 py-2">
                    <b-form @submit="onSubmit">
                        <div class="row">
                            <div class="col-11 ml-4 mr-4 text-center">
                                <b-form-group id="input-group-1">
                                    <b-form-input
                                    type="text"
                                    id="nome"
                                    v-model="nome"
                                    placeholder="Nome"
                                    required
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-11 ml-4 mr-4 text-center">
                                <b-form-group id="input-group-2">
                                    <b-form-input
                                    type="email"
                                    id="email"
                                    v-model="email"
                                    placeholder="E-mail"
                                    required
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-11 ml-4 mr-4 text-center">
                                <b-form-group id="input-group-3">
                                    <the-mask
                                        :mask="['###.###.###-##', '##.###.###/####-##']"
                                        id="documento"
                                        v-model="documento"
                                        placeholder="Documento"
                                        class="form-control"
                                    />
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-11 ml-4 mr-4 text-center">
                                <b-form-group id="input-group-3">
                                    <the-mask
                                        mask="(##) #####-####"
                                        id="telefone"
                                        v-model="telefone"
                                        placeholder="Telefone"
                                        class="form-control"
                                    />
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-11 ml-4 mr-4 mt-4 text-center">
                                <b-form-select :options="aAssuntos" v-model="assunto" id="assunto"> 
                                </b-form-select>
                                <hr style="background-color: #084f84;" class="mt-4">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-11 ml-4 mr-4 text-center">
                                <b-form-group id="input-group-4">
                                <b-form-textarea
                                id="mensagem"
                                placeholder="Mensagem"
                                rows="4"
                                v-model="mensagem"
                                max-rows="6"
                                ></b-form-textarea>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-11 ml-4 mr-4 text-center">
                                <br  v-if="mensagem_enviada || mensagem_enviada == null">
                                <b-button variant="danger" class="btenv" block v-if="!mensagem_enviada && mensagem_enviada != null">Não foi possivel realizar o contato</b-button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-11 ml-4 mr-4 text-center">
                                <b-button variant="success" class="btenv" block v-if="mensagem_enviada">Contato realizado </b-button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-11 ml-4 mr-4 text-center">
                                <b-button variant="primary" class="btenv" @click="enviar" block v-if="!mensagem_enviada && !loading">Enviar</b-button> 
                                <b-button variant="primary" class="bterr" block v-if="loading">
                                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                                </b-button> 
                              
                            </div>
                        </div>
                    </b-form>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>
<script>
import { TheMask } from "vue-the-mask";
import Serv from "../../services";
import API from "../../services/api";
export default {
    components: {
        TheMask
    },
    data(){
        return{
            nome:null,
            email:null,
            telefone:null,
            mensagem:null,
            loading:null,
            mensagem_enviada:null,
            assunto:0,
            documento:null,
            aAssuntos: [
                { value: 0, text: "Assunto" },
                { value: 1, text: "Certidão" },
                { value: 2, text: "Consulta" },
                { value: 3, text: "Envio de títulos a protesto" },
                { value: 4, text: "Dúvidas" },
                { value: 5, text: "Outros assuntos" },
                { value: 6, text: "Sugestão" },
                { value: 7, text: "Reclamação" },
                { value: 8, text: "Elogio" }
      ],
        }
    },
    methods: {
        onSubmit: function(){

        },
        validar() {
            let self = this;
            let campos = [
                "nome",
                "documento",
                "email",
                "telefone",
                "assunto",
                "mensagem"
            ];
            let erros = 0;

            // verifica campos
            campos.forEach(campo => {
                erros += self.isInvalid(campo, self[campo]) ? 1 : 0;
            });
                //email
            const d = { ...this.$data };
            if (!Serv.validarEmail(d.email)) {
                document.getElementById("email").classList.add("is-invalid");
                return false;
            }
            return erros > 0 ? false : true;
        },
        enviar() {
            let self = this;
            if (this.validar()) {
                const d = { ...this.$data };
                const dados = {
                nome: d.nome,
                email: d.email,
                documento: d.documento,
                telefone: d.telefone,
                assunto: d.assunto,
                mensagem: d.mensagem
                };
                this.loading = true;

                API.post("contato", dados).then(res => {
                if (res.data.enviada) {
                    self.loading = false;
                    self.mensagem_enviada = true;
                } else {
                    self.loading = false;
                    self.mensagem_enviada = false;
                }
                }).catch( () => {
                    this.loading = false;
                    this.mensagem_enviada = false;
                } )
                   
            }
        },
        isInvalid(field, value)
        {
            if(field == 'mensagem')
            {
                if (!value) document.getElementById(field).classList.add("isInvalidMensagem");
                else document.getElementById(field).classList.remove("isInvalidMensagem");
            }
            if (!value) document.getElementById(field).classList.add("is-invalid");
            else document.getElementById(field).classList.remove("is-invalid");
            return value ? false : true;
        }
    }
    
}
</script>
<style scoped>
    .entreemcontato{
        margin-top: calc(10%);
        font-size: 40px;
        color: #084f84;
        font-weight: bold;
    }
    .form-control{
        width: 100%;
        height: 100%;
        background: none;
        border:none;
        border-bottom : 1px solid #084f84;
        border-radius: 0;
        font-family: "Kanit", sans-serif !important;
        font-size: 18px;
        letter-spacing: 2px;
        margin-top: calc(10%);
    }
   .form-control:focus {
        box-shadow: 0 0 0 0;
        border: 0 none;
        outline: 0;
    }
    #textarea{
        border : 1px solid #084f84;
        border-radius: 10px;
    }
 
    .btenv{
        margin-top: calc(10%);
        height:50px;
    }
    .bterr{
        margin-top: calc(5%);
        height:50px;
    }
    
    .btn-fechar{
        cursor: pointer;
    }
    .isInvalid{
         border-bottom : 1px solid red;
    }
    .isInvalidMensagem{
         border : 1px solid red;
    }
   
</style>